export const FRAME_PRODUCTS_V2 = [
  {
    id: "marco-duo",
    slug: "marco-duo",
    category: "frames_multi",
    type: "duo",
    name: "Marco Duo",
    shortDescription: "Marco doble para presentar dos imanes personalizados de 5x5 cm.",
    price: 0,
    currency: "EUR",
    quantities: [1, 2, 3, 4],
    magnetSlots: 2,
    pieceSizeCm: 5,
    includesMagnets: false,
    active: true,
    order: 5001,
  },
  {
    id: "marco-mosaico",
    slug: "marco-mosaico",
    category: "frames_multi",
    type: "mosaic",
    name: "Marco Mosaico",
    shortDescription: "Marco para cuatro imanes personalizados de 5x5 cm en composicion 2x2.",
    price: 0,
    currency: "EUR",
    quantities: [1, 2, 3, 4],
    magnetSlots: 4,
    pieceSizeCm: 5,
    includesMagnets: false,
    active: true,
    order: 5002,
  },
  {
    id: "marco-secuencia",
    slug: "marco-secuencia",
    category: "frames_multi",
    type: "sequence",
    name: "Marco Secuencia",
    shortDescription: "Marco horizontal para presentar cuatro imanes personalizados de 5x5 cm.",
    price: 0,
    currency: "EUR",
    quantities: [1, 2, 3, 4],
    magnetSlots: 4,
    pieceSizeCm: 5,
    includesMagnets: false,
    active: true,
    order: 5003,
  },
];

export function getFrameProductV2(productId) {
  return FRAME_PRODUCTS_V2.find((product) => product.id === productId);
}
